module.exports = __webpack_public_path__ + "static/media/image16.7adafc60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/preConference/image16.jpg
// module id = 1129
// module chunks = 0